import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type State = {
  version: string;
  hasBeenUpdated: boolean;
  hasUpdate: boolean;
  isLoading: boolean;
};

const useVersionStore = create(
  persist<State>(
    () => ({
      version: "",
      hasBeenUpdated: false,
      hasUpdate: false,
      isLoading: false,
    }),
    {
      name: "PWA_VERSION",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        hasBeenUpdated: state.hasBeenUpdated,
        hasUpdate: false,
        isLoading: false,
        version: "",
      }),
    },
  ),
);

export const setVersionState = (isLoading: boolean, hasUpdate?: boolean) =>
  useVersionStore.setState({ isLoading, hasUpdate: hasUpdate ?? false });
export const setVersion = (version: string) => useVersionStore.setState({ version });
export const setHasBeenUpdated = (hasBeenUpdated: boolean) => useVersionStore.setState({ hasBeenUpdated });

export default useVersionStore;
